import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, unref as _unref, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-semibold mb-1" }, "Manage Teachers"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-tertiary" }, "Manage Teachers' access and permissions.")
], -1)
const _hoisted_2 = { class: "p-8 relative" }
const _hoisted_3 = { class: "flex items-center justify-start mb-6" }
const _hoisted_4 = { class: "ml-3" }
const _hoisted_5 = { class: "text-lg font-semibold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-tertiary" }, "Set up an account for a Teacher so they can log in.", -1)
const _hoisted_7 = {
  key: 0,
  class: "mb-4 p-4 bg-red-50 text-red-500 text-sm rounded-md flex items-center justify-start gap-2"
}
const _hoisted_8 = { class: "flex gap-4 w-full" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-slate-700 text-sm font-medium" }, "First Name", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*", -1)
const _hoisted_11 = {
  key: 0,
  class: "absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none flex items-center"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-slate-700 text-sm font-medium" }, "Surname", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*", -1)
const _hoisted_14 = {
  key: 0,
  class: "absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none flex items-center"
}
const _hoisted_15 = { class: "flex gap-4 w-full" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-slate-700 text-sm font-medium" }, "Email", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*", -1)
const _hoisted_18 = {
  key: 0,
  class: "absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none flex items-center"
}
const _hoisted_19 = {
  key: 0,
  class: "absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none flex items-center"
}
const _hoisted_20 = { class: "flex gap-4 w-full" }
const _hoisted_21 = { class: "flex w-full justify-center mt-8 border-t border-[#EAECF0] pt-8 flex-col gap-2" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 0,
  class: "inline-block me-2",
  role: "status"
}

import { ref, computed, watch, onMounted } from "vue";
import { useUserStore } from "@/stores/userStore";
import { useSchoolStore } from "@/stores/schoolStore";
import { useSubjectStore } from "@/stores/subjectStore";
import { useAdminStore } from "@/stores/adminStore";
import { useLearnerStore } from "@/stores/learnerStore";
import { useFilterStore } from "@/stores/filterStore";
import { useGradeSubjectFilterOptions } from "@/composables/useGradeSubjectFilterOptions";
import { FormKitNode } from "@formkit/core";
import {
  TrashIcon,
  XMarkIcon,
} from "@heroicons/vue/24/outline";
import { unionBy } from "lodash";
import { CheckCircleIcon, ExclamationCircleIcon } from "@heroicons/vue/20/solid";
import { showToast } from '@/utils/toastUtils';
import { useI18n } from 'vue-i18n'
import TeachersTableComponent from '@/modules/main/components/TeachersTableComponent.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TeachersViewNew',
  setup(__props) {

const pages = [{
  name: 'Manage Teachers',
  path: '/teachersnew'
}];

const { t } = useI18n();

function notifySuccess() {
  showToast({
    text: t('internal_view.delete_teacher_success'),
    type: 'success',
    icon: CheckCircleIcon,
  })
}

function notifyError() {
  showToast({
    text: t('internal_view.delete_teacher_error'),
    type: 'error',
    icon: ExclamationCircleIcon,
  })
}

function notifySuccessSaving() {
  showToast({
    text: t('admin_screens.alerts.success_updated'),
    type: 'success',
    icon: CheckCircleIcon,
  })
}

function notifySuccessNewTeacher() {
  showToast({
    text: t('admin_screens.alerts.success_saved'),
    type: 'success',
    icon: CheckCircleIcon,
  })
}


// stores
const schoolStore = useSchoolStore();
const subjectStore = useSubjectStore();
const learnerStore = useLearnerStore();
const adminStore = useAdminStore();
const filterStore = useFilterStore();
const userStore = useUserStore();

const availableSubjects = schoolStore?.getCurrentSchool?.subjectsAvailable;

// Use teacher ID for toggle functionality
const selectedTeacherId = ref<string | null>("");

const loading = ref<boolean>(false);

const formData = ref({
  firstName: "",
  lastName: "",
  designation: "",
  email: "",
  phoneNumber: "",
});

const saveSuccess = ref(false);

// Watch the selected teacher and update formData
// watch(
//   () => selectedTeacherId.value,
//   (newTeacherId) => {
//     const teacher = schoolTeachers.value.find((t) => t._id === newTeacherId);
//     if (teacher) {
//       formData.value = {
//         firstName: teacher.firstName,
//         lastName: teacher.lastName,
//         designation: teacher.designation,
//         email: teacher.email,
//         phoneNumber: teacher.phoneNumber || "",
//       };
//     }
//   }
// );

const schoolGroupId = schoolStore.currentSchoolStructure?.schoolGroup ?? "";
const schoolId = schoolStore.currentSchoolStructure?._id ?? "";

// show add teacher modal
const addTeacherModal = ref<boolean>(false);

const addTeacher = () => {
  addTeacherModal.value = true;
};

const closeModals = () => {
  addTeacherModal.value = false;
};

const designationOptions = [
    { label: "Class Teacher", value: "Class Group Admin" },
    { label: "School Champion", value: "School Champion" },
    { label: "School Group Champion", value: "School Group Champion" },
];

// Reactive object for new teacher data
const newTeacher = ref({
  firstName: "",
  lastName: "",
  designation: "Class Group Admin",
  email: "",
  phoneNumber: "",
  schoolGroup: schoolGroupId,
  school: schoolId,
});

const formError = ref<string | null>(null);
const formErrorAlert = ref<boolean>(false);
const nameCheckInProgress = ref(false);

watch(
  () => [newTeacher.value.firstName, newTeacher.value.lastName],
  async ([firstName, lastName]) => {
    formError.value = null;
    formErrorAlert.value = false;

    const trimmedFirst = firstName?.trim();
    const trimmedLast = lastName?.trim();

    if (!trimmedFirst || !trimmedLast) return;

    nameCheckInProgress.value = true;

    try {
      const exists = await adminStore.fullNameExists(trimmedFirst, trimmedLast, schoolId);
      if (exists) {
        formError.value = "There is already another Teacher in the School with the same First name and Surname. You might be trying to create a duplicate user.";
        formErrorAlert.value = true;
        buttonIsDisabled.value = true;
      } else {
        formErrorAlert.value = false;
        buttonIsDisabled.value = false;
      }
    } catch (error) {
      console.error("Error checking full name:", error);
      formError.value = "An error occurred while checking the name.";
      formErrorAlert.value = true;
      buttonIsDisabled.value = true;
    } finally {
      nameCheckInProgress.value = false;
    }
  }
);

const buttonIsDisabled = ref(false);

const email_exists = async (node: FormKitNode): Promise<boolean> => {
  try {
    const emailExists = await schoolStore?.validateEmail(node.value as string);
    buttonIsDisabled.value = emailExists; // Disable button if email exists
    return !emailExists; // Validation passes if email does not exist
  } catch (error) {
    buttonIsDisabled.value = true; // Disable on error
    return true;
  }
};

const full_name_exists = async (node: FormKitNode): Promise<boolean> => {
  try {
    const firstName = newTeacher.value.firstName?.trim();
    const lastName = newTeacher.value.lastName?.trim();
    // Only run check if both fields have values
    if (!firstName || !lastName) return true;
    const exists = await adminStore.fullNameExists(firstName, lastName, schoolId);
    buttonIsDisabled.value = exists;
    return !exists;
  } catch (error) {
    console.error("Name check failed:", error);
    buttonIsDisabled.value = true;
    return true; // Allow form to proceed (you may return false if you prefer to block)
  }
};

function normalizePhoneNumber(phone: string): string {
  return phone.replace(/\D/g, ''); // remove all non-digit characters
}

const phone_exists = async ({ value }: { value: string }) => {
  try {
    if (!value) return true;

    const normalizedPhone = normalizePhoneNumber(value.trim());
    const exists = await adminStore.phoneNumberExists(normalizedPhone, schoolId);
    buttonIsDisabled.value = exists;
    return !exists;
  } catch (error) {
    console.error("Phone check failed:", error);
    buttonIsDisabled.value = true;
    return true; // Fallback: allow submission
  }
};

// save new teacher form
const saveNewTeacher = async () => {
  formError.value = null;
  formErrorAlert.value = false;
  // Normalize phone number before saving
  newTeacher.value.phoneNumber = normalizePhoneNumber(newTeacher.value.phoneNumber);
  newTeacher.value.email = newTeacher.value.email?.trim().toLowerCase();

  loading.value = true;
  buttonIsDisabled.value = true;
  console.log("New teacher added successfully:", newTeacher.value);
  try {
    const firstName = newTeacher.value.firstName?.trim();
    const lastName = newTeacher.value.lastName?.trim();

    if (!firstName || !lastName) {
      formError.value = "Please enter both a first and last name.";
      formErrorAlert.value = true;
      return;
    }

    const exists = await adminStore.fullNameExists(firstName, lastName, schoolId);
    if (exists) {
      formError.value = "A teacher with that name already exists.";
      formErrorAlert.value = true;
      return;
    }

    let request = await schoolStore.addNewTeacherToSchool(newTeacher.value);
    
    if (request === undefined) {
      saveSuccess.value = false;
      showToast({
        text: 'Error, please try again.',
        type: 'error',
        icon: ExclamationCircleIcon,
      });
      return;
    }

    saveSuccess.value = true;
    notifySuccessNewTeacher();

    // Close modal after saving
    closeModals();

    // Reset form fields
    newTeacher.value = {
      firstName: "",
      lastName: "",
      designation: "Class Group Admin",
      email: "",
      phoneNumber: "",
      schoolGroup: schoolGroupId,
      school: schoolId,
    };
    saveSuccess.value = false;
  } catch (error) {
    console.error(error);
    saveSuccess.value = false;
    showToast({
      text: 'Error, please try again.',
      type: 'error',
      icon: ExclamationCircleIcon,
    });
  } finally {
    // Always re-enable the submit button on every exit path (success included),
    // matching ClassesViewNew — the success path previously left it disabled.
    buttonIsDisabled.value = false;
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_page_title, { pages: pages }),
    _createElementVNode("div", { class: "flex align-center justify-between mb-4" }, [
      _hoisted_1,
      _createElementVNode("div", { class: "flex gap-2 items-center justify-end" }, [
        _createElementVNode("button", {
          class: "font-semibold bg-blue-600 rounded-lg py-2 px-6 text-white mt-4 mx-2 flex flex-row justify-center items-center flex-wrap",
          onClick: addTeacher
        }, "Add Teacher")
      ])
    ]),
    _createVNode(TeachersTableComponent),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-3xl',
      open: addTeacherModal.value,
      onLocalModalOpen: _cache[5] || (_cache[5] = ($event: any) => (addTeacherModal.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-add-teacher',
                title: 'rl add teacher',
                class: "h-12 w-12 text-blue-600 mx-auto mb-4",
                "aria-hidden": "true"
              }),
              _createElementVNode("span", _hoisted_4, [
                _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t("admin_screens.teacher_details_screen.add_teacher")), 1),
                _hoisted_6
              ])
            ]),
            (formErrorAlert.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_rl_icon, {
                    icon: 'rl-alert-error',
                    title: 'rl alert error',
                    class: "h-8 w-8 text-red-500",
                    "aria-hidden": "true"
                  }),
                  _createElementVNode("span", null, _toDisplayString(formError.value), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createVNode(_component_FormKit, {
                type: "form",
                id: "login-form",
                actions: false,
                config: { validationVisibility: 'submit' },
                onSubmit: saveNewTeacher
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_FormKit, {
                      type: "text",
                      name: "First Name",
                      placeholder: "First Name",
                      modelValue: newTeacher.value.firstName,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newTeacher.value.firstName) = $event)),
                      validation: "required|length:0,20|full_name_exists",
                      "validation-rules": { full_name_exists: full_name_exists },
                      "input-class": "w-full",
                      "outer-class": "mb-4 w-full",
                      "validation-messages": {
                        length: 'First Name must be 20 characters or fewer.',
                        required: 'First Name is required.'
                      }
                    }, {
                      label: _withCtx(() => [
                        _hoisted_9,
                        _hoisted_10
                      ]),
                      suffix: _withCtx(({ node }) => [
                        (!node.context?.state.valid && node.context?.state.validationVisible)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createVNode(_component_rl_icon, {
                                icon: "rl-alert-error",
                                title: "Error",
                                "aria-hidden": "true"
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "validation-rules", "validation-messages"]),
                    _createVNode(_component_FormKit, {
                      type: "text",
                      name: "Surname",
                      placeholder: "Surname",
                      modelValue: newTeacher.value.lastName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newTeacher.value.lastName) = $event)),
                      validation: "required|length:0,20|full_name_exists",
                      "validation-rules": { full_name_exists: full_name_exists },
                      "input-class": "w-full",
                      "outer-class": "mb-4 w-full",
                      "validation-messages": { 
                        email_exists: 'This field is not valid.',
                        length: 'Surname must be 20 characters or fewer.'
                       }
                    }, {
                      label: _withCtx(() => [
                        _hoisted_12,
                        _hoisted_13
                      ]),
                      suffix: _withCtx(({ node }) => [
                        (!node.context?.state.valid && node.context?.state.validationVisible)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _createVNode(_component_rl_icon, {
                                icon: "rl-alert-error",
                                title: "Error",
                                "aria-hidden": "true"
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "validation-rules", "validation-messages"])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_FormKit, {
                      type: "email",
                      name: "Email",
                      placeholder: "Email",
                      "outer-class": "mb-4 w-full",
                      modelValue: newTeacher.value.email,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newTeacher.value.email) = $event)),
                      "input-class": "w-full",
                      validation: "required|email|(500)email_exists",
                      "validation-rules": { email_exists: email_exists },
                      "validation-messages": {
                      email_exists: _ctx.$t(
                          'add_grades_class_component.step_1.email_exists'
                      )
                    }
                    }, {
                      label: _withCtx(() => [
                        _hoisted_16,
                        _hoisted_17
                      ]),
                      suffix: _withCtx(({ node }) => [
                        (!node.context?.state.valid && node.context?.state.validationVisible)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              _createVNode(_component_rl_icon, {
                                icon: "rl-alert-error",
                                title: "Error",
                                "aria-hidden": "true"
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "validation-rules", "validation-messages"]),
                    _createVNode(_component_FormKit, {
                      type: "text",
                      name: "phoneNumber",
                      label: "Phone Number",
                      placeholder: "+27 (0) 000-0000",
                      "outer-class": "mb-4 w-full",
                      "input-class": "w-full",
                      modelValue: newTeacher.value.phoneNumber,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newTeacher.value.phoneNumber) = $event)),
                      validation: "phone_exists",
                      "validation-rules": { phone_exists: phone_exists },
                      "validation-messages": { phone_exists: 'There is already another Teacher in this School using this phone number.' }
                    }, {
                      suffix: _withCtx(({ node }) => [
                        (!node.context?.state.valid && node.context?.state.validationVisible)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createVNode(_component_rl_icon, {
                                icon: "rl-alert-error",
                                title: "Error",
                                "aria-hidden": "true"
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "validation-rules", "validation-messages"])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    (_unref(userStore).isInternalAdmin)
                      ? (_openBlock(), _createBlock(_component_FormKit, {
                          key: 0,
                          type: "select",
                          label: "Type",
                          placeholder: "Position",
                          modelValue: newTeacher.value.designation,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newTeacher.value.designation) = $event)),
                          options: designationOptions,
                          validation: "required",
                          "outer-class": "w-1/2 pr-2"
                        }, null, 8, ["modelValue"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("button", {
                      type: "submit",
                      disabled: buttonIsDisabled.value || loading.value,
                      class: "text-white border border-blue-600 bg-blue-600 text-sm font-semibold px-4 py-2.5 rounded-lg items-center flex-wrap disabled:opacity-50 disabled:cursor-not-allowed w-full"
                    }, [
                      (loading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' })
                          ]))
                        : _createCommentVNode("", true),
                      _createTextVNode(" Add Teacher and Send Welcome Email ")
                    ], 8, _hoisted_22),
                    _createElementVNode("button", {
                      onClick: closeModals,
                      class: "text-gray-700 border border-gray-300 text-sm font-semibold px-4 py-2.5 bg-white rounded-lg mr-3 items-center flex-wrap w-full"
                    }, _toDisplayString(_ctx.$t("admin_screens.teacher_details_screen.cancel")), 1)
                  ])
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})